var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgWrapper',{attrs:{"viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"currentColor","d":"M64 16v480h32V360h352v-37.238L363.841 208L448 93.238V56H96V16Zm348.159 72l-88 120l88 120H96V88Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }